import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="font-heading text-2xl text-primary-500 font-bold whitespace-nowrap">51黑料网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1 overflow-x-auto">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-500 text-white"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-primary-500 text-white"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/60 mt-2 pt-2">
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? "bg-primary-500 text-white"
                      : "text-foreground-700 bg-background-100 hover:bg-background-200"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                  location.pathname === "/about"
                    ? "bg-primary-500 text-white"
                    : "text-foreground-700 bg-background-100 hover:bg-background-200"
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}